/**
 * PortalEventSymbol.js
 *
 * Copyright (c) apploft. GmbH
 */

const authorize = Symbol('request access');
const authorizationFailed = Symbol('authorization failed');
const authorizationSucceeded = Symbol('authorization succeeded');

export {authorize, authorizationFailed, authorizationSucceeded};
